/* IB-7 Designsystem v2: Interaktionen (Vanilla JS, defer).
   Header, Dropdowns, Drawer, Galerie, Sticky-Kaufleiste, Vorher/Nachher, Optimum-Skala, Kennzahlen, Filter, Quiz.
   Warenkorb (Cart AJAX API) liegt in assets/ib7-cart.js und nutzt window.IB7.openDrawer. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = function () { return window.matchMedia('(hover: hover)').matches; };

  /* ---------- Drawer ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.querySelectorAll('[data-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var c = d.querySelector('.icon-btn[data-close]');
    if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function closeDrawers() {
    var any = document.querySelector('.drawer.is-open');
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.querySelectorAll('[data-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.documentElement.style.overflow = '';
    if (any && lastFocus) lastFocus.focus();
  }
  window.IB7 = window.IB7 || {};
  window.IB7.openDrawer = openDrawer;
  window.IB7.closeDrawers = closeDrawers;

  function init() {
    /* Ankündigung rotieren */
    var items = document.querySelectorAll('.announce__item'), ai = 0;
    if (items.length > 1 && !reduce) {
      setInterval(function () { items[ai].classList.remove('is-active'); ai = (ai + 1) % items.length; items[ai].classList.add('is-active'); }, 4500);
    }

    /* Header: über dem Hero transparent */
    var hdr = document.querySelector('[data-header]');
    var hero = document.querySelector('.hero');
    var over = hdr && hdr.hasAttribute('data-over') && hero;
    var openDD = null;
    function onScroll() {
      if (!hdr) return;
      hdr.classList.toggle('is-scrolled', window.scrollY > 8);
      if (over) hdr.classList.toggle('header--over', !openDD && window.scrollY < hero.offsetHeight - 120);
    }
    if (hdr && !over) hdr.classList.remove('header--over');
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Dropdowns (Desktop) */
    function setDD(id) {
      document.querySelectorAll('.dropdown').forEach(function (d) { d.classList.toggle('is-open', d.id === id); });
      document.querySelectorAll('[data-dd]').forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-dd') === id)); });
      openDD = id;
      if (id && hdr) hdr.classList.remove('header--over'); else onScroll();
    }
    document.querySelectorAll('[data-dd]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-dd');
        if (canHover()) setDD(id); else setDD(openDD === id ? null : id);
      });
      b.addEventListener('mouseenter', function () { if (canHover()) setDD(b.getAttribute('data-dd')); });
    });
    if (hdr) hdr.addEventListener('mouseleave', function () { if (canHover()) setDD(null); });

    /* Klicks */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-open],[data-close],[data-thumb],[data-dot],[data-filter]');
      if (!t) return;
      if (t.hasAttribute('data-open')) { e.preventDefault(); openDrawer(t.getAttribute('data-open')); }
      else if (t.hasAttribute('data-close')) { closeDrawers(); }
      else if (t.hasAttribute('data-thumb') || t.hasAttribute('data-dot')) {
        var root = t.closest('.gallery');
        var i = Number(t.getAttribute('data-thumb') || t.getAttribute('data-dot'));
        var tr = root && root.querySelector('.gallery__track');
        var s = tr && tr.children[i];
        if (s) tr.scrollTo({ left: s.offsetLeft - tr.offsetLeft - parseFloat(getComputedStyle(tr).paddingLeft || 0), behavior: reduce ? 'auto' : 'smooth' });
      } else if (t.hasAttribute('data-filter')) {
        var v = t.getAttribute('data-filter');
        var scope = t.closest('[data-filter-scope]') || document;
        scope.querySelectorAll('[data-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === t)); });
        scope.querySelectorAll('[data-prod]').forEach(function (r) {
          var list = (r.getAttribute('data-prod') || '').split(' ');
          r.hidden = !(v === 'all' || list.indexOf(v) > -1);
        });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); setDD(null); } });

    /* Galerie: aktiver Punkt / Thumbnail */
    document.querySelectorAll('.gallery').forEach(function (g) {
      var tr = g.querySelector('.gallery__track');
      if (!tr) return;
      var marks = g.querySelectorAll('[data-thumb],[data-dot]');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting && x.intersectionRatio > 0.6) {
            var i = Array.prototype.indexOf.call(tr.children, x.target);
            marks.forEach(function (m) { m.setAttribute('aria-current', String(Number(m.getAttribute('data-thumb') || m.getAttribute('data-dot')) === i)); });
          }
        });
      }, { root: tr, threshold: [0.6] });
      Array.prototype.forEach.call(tr.children, function (s) { io.observe(s); });
    });

    /* Sticky Kaufleiste (mobil) */
    var sticky = document.querySelector('.sticky-buy');
    var atc = document.querySelector('[data-main-atc]');
    if (sticky && atc) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(atc);
    }

    /* Vorher / Nachher */
    document.querySelectorAll('.ba input[type="range"]').forEach(function (r) {
      var set = function () { r.closest('.ba').style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
    });

    /* Optimum-Skala */
    document.querySelectorAll('[data-scale]').forEach(function (sc) {
      var marks = sc.querySelectorAll('.srow__mark--mix');
      if (reduce) { marks.forEach(function (m) { m.style.left = m.getAttribute('data-pos') + '%'; }); return; }
      marks.forEach(function (m) { m.style.left = '50%'; });
      new IntersectionObserver(function (en, obs) {
        if (!en[0].isIntersecting) return;
        marks.forEach(function (m, i) { setTimeout(function () { m.style.left = m.getAttribute('data-pos') + '%'; }, i * 120); });
        obs.disconnect();
      }, { threshold: 0.35 }).observe(sc);
    });

    /* Kennzahlen zählen hoch (Startwert ist der fertige Text) */
    document.querySelectorAll('[data-count]').forEach(function (el) {
      if (reduce) return;
      var target = Number(el.getAttribute('data-count'));
      if (!isFinite(target) || target <= 0) return;
      var final = el.textContent;
      var suffix = el.getAttribute('data-suffix') || '';
      var dec = Number(el.getAttribute('data-dec') || 0);
      var fmt = function (v) { return v.toLocaleString('de-AT', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suffix; };
      new IntersectionObserver(function (en, obs) {
        if (!en[0].isIntersecting) return;
        obs.disconnect();
        var t0 = performance.now();
        (function tick(t) {
          var k = Math.min(1, (t - t0) / 1400);
          el.textContent = k < 1 ? fmt(target * (1 - Math.pow(1 - k, 3))) : final;
          if (k < 1) requestAnimationFrame(tick);
        })(t0);
      }, { threshold: 0.5 }).observe(el);
    });

    /* Set-Auswahl: Preis, Grundpreis und Sticky-Variante mitführen */
    document.querySelectorAll('.choice').forEach(function (choice) {
      var radios = choice.querySelectorAll('input[type="radio"][data-price]');
      if (!radios.length) return;
      var section = choice.closest('.pdp') || document;
      var first = radios[0];
      function sync(r) {
        var isFirst = r === first;
        document.querySelectorAll('[data-dynamic="price"]').forEach(function (el) { el.textContent = r.getAttribute('data-price'); });
        var unit = r.getAttribute('data-unit');
        section.querySelectorAll('[data-dynamic="unit"]').forEach(function (el) {
          if (unit) el.textContent = r.getAttribute('data-size') + ' · ' + unit;
        });
        var perUse = r.getAttribute('data-per-use');
        section.querySelectorAll('[data-dynamic="per-use"]').forEach(function (el) {
          el.textContent = perUse || '';
          el.hidden = !perUse;
        });
        section.querySelectorAll('.buy .price__was, .buy .price__save').forEach(function (el) { el.hidden = !isFirst; });
        document.querySelectorAll('.sticky-buy .price__was').forEach(function (el) { el.hidden = !isFirst; });
        document.querySelectorAll('[data-sticky-id]').forEach(function (el) { el.value = r.value; });
      }
      radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) sync(r); }); });
      var checked = choice.querySelector('input[type="radio"]:checked');
      if (checked && checked !== first) sync(checked);
    });

    document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  }

  /* ---------- Ritual-Check ---------- */
  function initQuiz(root) {
    var cfgEl = root.querySelector('script[type="application/json"]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var Q = cfg.questions || [];
    var a = [], i = 0;
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
    var arrow = root.querySelector('template[data-arrow]');
    var arrowHTML = arrow ? arrow.innerHTML : '';
    var stage = root.querySelector('[data-quiz-stage]');
    function render() {
      if (i < Q.length) {
        stage.innerHTML = '<div class="quiz__progress" aria-hidden="true"><b style="width:' + (i / Q.length * 100) + '%"></b></div>' +
          '<p class="micro">' + esc(cfg.label_step.replace('[n]', i + 1).replace('[total]', Q.length)) + '</p>' +
          '<h2 class="h3 quiz__q">' + esc(Q[i].q) + '</h2><div class="quiz__opts">' +
          Q[i].a.map(function (o, j) { return '<button class="quiz__opt" type="button" data-a="' + j + '">' + esc(o) + arrowHTML + '</button>'; }).join('') + '</div>' +
          (i ? '<button class="link quiz__back" type="button" data-back>' + esc(cfg.label_back) + '</button>' : '');
        stage.querySelectorAll('[data-a]').forEach(function (b) { b.addEventListener('click', function () { a[i] = Number(b.getAttribute('data-a')); i++; render(); }); });
        var bk = stage.querySelector('[data-back]');
        if (bk) bk.addEventListener('click', function () { i--; render(); });
        var first = stage.querySelector('[data-a]');
        if (first && a.length) first.focus();
        return;
      }
      /* Ergebnis: Duftfrei + feineres Hautbild -> Serum, sonst Duo */
      var rec = (a[3] === 0 && a[2] === 0) ? 'single' : 'duo';
      var mix = a[1] === 2 || a[0] === 2;
      stage.hidden = true;
      root.querySelectorAll('[data-result]').forEach(function (r) { r.hidden = r.getAttribute('data-result') !== rec; });
      root.querySelectorAll('[data-result-mix]').forEach(function (r) { r.hidden = (r.getAttribute('data-result-mix') === 'true') !== mix; });
      var res = root.querySelector('[data-quiz-result]');
      res.hidden = false;
      var h = res.querySelector('h2');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
    }
    var restart = root.querySelector('[data-restart]');
    if (restart) restart.addEventListener('click', function () {
      a = []; i = 0; stage.hidden = false;
      root.querySelector('[data-quiz-result]').hidden = true;
      render();
    });
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
